(function() {
  function initTUSStyles() {
    // This injects the grid CSS directly so it can't be ignored
    const style = document.createElement('style');
    style.innerHTML = `
      #MainContent .ais-Hits-list {
        display: grid !important;
        grid-template-columns: repeat(4, 1fr) !important;
        gap: 20px !important;
        list-style: none !important;
        padding: 0 !important;
      }
      @media (max-width: 749px) {
        #MainContent .ais-Hits-list { grid-template-columns: repeat(2, 1fr) !important; }
      }
      .ais-Hits-item { 
        border: 1px solid #e8e8e8 !important; 
        text-align: left !important;
        border-radius: 4px !important;
        background: white !important;
      }
    `;
    document.head.appendChild(style);
  }

  function tryRegisterHooks() {
    if (window.algoliaShopify && window.algoliaShopify.hooks) {
      initTUSStyles(); // Load the CSS first
      
      algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, templateOptions) {
        const { html, item } = templateOptions;
        const price = (item.price / 100).toFixed(2);

        return html`
          <div class="grid__item">
            <div class="card-wrapper">
              <div class="card card--standard">
                <div class="card__inner">
                  <a href="${item.url}"><img src="${item.image_url}" style="width:100%; display:block;"></a>
                </div>
                <div class="card__content" style="padding: 15px; text-align: left;">
                  <p style="text-transform: uppercase; font-size: 10px; color: #777; margin: 0;">${item.vendor}</p>
                  <h3 style="font-size: 14px; margin: 5px 0; font-weight: 600; color: #121212;">${item.title}</h3>
                  <p style="font-weight: bold; margin: 0; color: #121212;">From $${price}</p>
                </div>
              </div>
            </div>
          </div>
        `;
      });
    } else {
      setTimeout(tryRegisterHooks, 50);
    }
  }
  tryRegisterHooks();
})();